<script setup>
import DoubleArrowRight from '../../shared/icons/DoubleArrowRight.vue';
import DoubleArrowLeft from '../../shared/icons/DoubleArrowLeft.vue';
import DoubleArrowDown from '../../shared/icons/DoubleArrowDown.vue';
import DoubleArrowUp from '../../shared/icons/DoubleArrowUp.vue';
import { useWindowSize } from '@vueuse/core';
import { computed } from "vue";

import { defineProps, defineEmits } from "vue";

const props = defineProps({
    isCollapsed: {
        type: Boolean,
        required: true,
    },
});

const emit = defineEmits(["update:isCollapsed"]);

const { width } = useWindowSize();
const isVerticallyStacked = computed(() => width.value < 1200);

</script>

<template>
    <button
        @click.stop="emit('update:isCollapsed', !isCollapsed)"
        data-testid="collapse-sidebar"
        class="bg-blue-500 text-white text-xs rounded flex justify-center items-center h-[30px] w-[50px]"
    >
        <component
            :is="isVerticallyStacked ? 
                    isCollapsed ? DoubleArrowDown : DoubleArrowUp : 
                    isCollapsed ? DoubleArrowRight : DoubleArrowLeft "
            customClass="w-5 h-5 flex-shrink-0"
        />
    </button>


</template>